import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../atoms/Image';
import MarkdownContent from '../../../../../../components/MarkdownContent';
import WebsiteComponentInteraction from '../../../../../interactions/components/WebsiteComponentInteraction';
import { CuratedHeroVariantPropTypes, CuratedHeroVariantDefaultProps } from '../../../../types';
import { HERO_CONTENT_COMPONENT_ID, HERO_IMAGE_COMPONENT_ID, HERO_FEATURED_CONTENT_COMPONENT_ID } from '../../CuratedHero.constants';
import { getCuratedHeroConfiguration, getContentNodeContent, getImageAltText, getImageSource } from '../../CuratedHero.utils';
import './SoothingSerenity.less';
var defaultProps = CuratedHeroVariantDefaultProps;
export default function SoothingSerenity(_ref) {
  var componentConfigurations = _ref.componentConfigurations;
  var heroImageConfiguration = getCuratedHeroConfiguration(componentConfigurations, HERO_IMAGE_COMPONENT_ID);
  var heroContentConfiguration = getCuratedHeroConfiguration(componentConfigurations, HERO_CONTENT_COMPONENT_ID);
  var heroFeaturedContentConfiguration = getCuratedHeroConfiguration(componentConfigurations, HERO_FEATURED_CONTENT_COMPONENT_ID);
  if (_isEmpty(heroContentConfiguration)) {
    return null;
  }
  var _ref2 = heroImageConfiguration || {},
    _ref2$files = _ref2.files,
    files = _ref2$files === void 0 ? [] : _ref2$files;
  var _ref3 = heroContentConfiguration || {},
    _ref3$contentNodes = _ref3.contentNodes,
    contentNodes = _ref3$contentNodes === void 0 ? [] : _ref3$contentNodes,
    _ref3$interactions = _ref3.interactions,
    interactions = _ref3$interactions === void 0 ? [] : _ref3$interactions;
  var _ref4 = heroFeaturedContentConfiguration || {},
    _ref4$contentNodes = _ref4.contentNodes,
    featuredContentNodes = _ref4$contentNodes === void 0 ? [] : _ref4$contentNodes;
  var content = getContentNodeContent(contentNodes);
  var featuredContent = getContentNodeContent(featuredContentNodes);
  var image = _get(files, '[0]', {});
  return /*#__PURE__*/React.createElement("div", {
    className: "curated-hero soothing-serenity"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(MarkdownContent, {
    content: content
  }), !_isEmpty(interactions) && /*#__PURE__*/React.createElement("div", {
    className: "ctas-container"
  }, interactions.map(function (interaction) {
    var interactionId = interaction._id;
    return /*#__PURE__*/React.createElement(WebsiteComponentInteraction, {
      key: interactionId,
      interaction: interaction,
      displayComponentPropsMap: {
        button: {
          size: null,
          compact: false
        }
      }
    });
  }))), !_isEmpty(image) && !_isEmpty(featuredContent) && /*#__PURE__*/React.createElement("div", {
    className: "images-container"
  }, /*#__PURE__*/React.createElement(MarkdownContent, {
    content: featuredContent,
    className: "featured-content"
  }), /*#__PURE__*/React.createElement(Image, {
    src: getImageSource(image),
    altText: getImageAltText(image),
    background: true
  })));
}
SoothingSerenity.defaultProps = defaultProps;